module.exports = __webpack_public_path__ + "static/img/products_03.27370e8e.png";